import React from 'react';
import { Table, Button } from '@/components/ui';
import { VehicleProfile } from '../../../types/Vehicle';

interface VehicleProfileListProps {
  profiles: VehicleProfile[];
  onEdit: (profile: VehicleProfile) => void;
  onDelete: (profileId: number) => void;
  canEdit: boolean;
}

const VehicleProfileList: React.FC<VehicleProfileListProps> = ({ profiles, onEdit, onDelete, canEdit }) => {
  if (profiles.length === 0) {
    return <p>No profiles available. Create one to get started.</p>;
  }

  return (
    <Table striped responsive>
        <thead>
          <tr>
            <th>Inspection</th>
            <th>Vehicle Type</th>
            <th>Vehicle Classification</th>
            <th>PM Classification</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {profiles.map(profile => (
            <tr key={profile.id}>
              <td>{profile.inspection}</td>
              <td>{profile.vehicleType || '-'}</td>
              <td>{profile.vehicleClassification || '-'}</td>
              <td>{profile.pmClassification || '-'}</td>
              <td>
                {canEdit && (
                  <>
                    <Button
                      variant="primary"
                      size="sm"
                      className="tw-mr-2"
                      onClick={() => onEdit(profile)}
                    >
                      <i className="bi bi-pencil"></i> Edit
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => onDelete(profile.id)}
                    >
                      <i className="bi bi-trash"></i> Delete
                    </Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
  );
};

export default VehicleProfileList;

